import { AppBar, Box, Toolbar, Typography, useTheme } from '@mui/material'
import { Separator } from './Separator'
import { SwitchAppButton } from './SwitchAppButton'
import { HeaderProps } from './Header.types'

export const Header = ({
  brandLogo,
  brandLogoStyles,
  titleText,
  profileText,
  handleBrandLogoClick,
  tenantName,
  switchIcon,
  handleTenantSwitchClick,
  logoOne,
  logoTwo,
  handleLogoOneClick,
  handleLogoTwoClick,
  isClickable,
  leftElement,
}: HeaderProps) => {
  const theme = useTheme()

  return (
    <AppBar
      position="static"
      sx={{
        boxShadow: 'none',
        borderBottom: `3px solid ${theme.palette.secondary.main}`,
      }}
    >
      <Toolbar>
        <Box display="flex" flexGrow={1} alignItems="center">
          <Box
            sx={{ cursor: 'pointer' }}
            onClick={handleBrandLogoClick}
            role="button"
            aria-label="logo"
          >
            <img src={brandLogo} alt="Logo" style={brandLogoStyles} />
          </Box>
          {titleText && (
            <>
              <Separator height="44px" />
              <Box
                sx={{
                  fontSize: '22px',
                  textTransform: 'uppercase',
                }}
              >
                {titleText}
              </Box>
            </>
          )}
          {leftElement && (
            <>
              <Separator height="44px" />
              {leftElement}
            </>
          )}
        </Box>
        <Typography variant="h4">{profileText}</Typography>
        <Separator height="33px" />
        <Box
          sx={{ cursor: isClickable ? 'pointer' : 'default' }}
          onClick={
            isClickable && handleTenantSwitchClick
              ? handleTenantSwitchClick
              : undefined
          }
          role="button"
          aria-label="switch tenant"
        >
          <Box display="flex">
            <Box
              display={isClickable ? 'flex' : 'none'}
              alignItems="center"
              mr={1}
            >
              {switchIcon}
            </Box>
            <Typography variant="body1">{tenantName}</Typography>
          </Box>
        </Box>
        {logoOne && logoTwo && handleLogoOneClick && handleLogoTwoClick && (
          <>
            <Separator height="33px" />
            <SwitchAppButton
              logoOne={logoOne}
              logoTwo={logoTwo}
              handleLogoOneClick={handleLogoOneClick}
              handleLogoTwoClick={handleLogoTwoClick}
            />
          </>
        )}
      </Toolbar>
    </AppBar>
  )
}
